/** Plan-mode chip state for Week/Month with exactly one project filter. */
import { useEffect, useState } from 'react';

export function usePlanMode({ projectFilter, activeView }) {
  const [planMode, setPlanMode] = useState(false);
  const canUsePlanMode = projectFilter?.length === 1;

  useEffect(() => {
    if (planMode && (!canUsePlanMode || activeView === 0)) setPlanMode(false);
  }, [planMode, canUsePlanMode, activeView]);

  return {
    planMode,
    canUsePlanMode,
    onTogglePlanMode: () => setPlanMode((v) => !v),
  };
}
